import defaultAvatar from "@/public/assets/icons/default-avatar.svg"
import Image from "next/legacy/image"

export const DEFAULT_AVATAR = defaultAvatar.src

/**
 * Assume rem is 16px
 * tailwind w-10 is 2.5rem, i.e. 2.5 x 16px = 40px
 * Therefore, the calculation is usually (tw * 4)px, where tw is the tailwind number
 * See here: https://tailwindcss.com/docs/width#header
 */
const AVATAR_SIZES = {
  xs: [24, "w-6 h-6", "w-1.5 h-1.5"],
  sm: [32, "w-8 h-8", "w-2 h-2"],
  md: [40, "w-10 h-10", "w-2.5 h-2.5"],
  normal: [40, "w-10 h-10", "w-2.5 h-2.5"],
  lg: [48, "w-12 h-12", "w-3 h-3"]
}

const DOT_OPTIONS = {
  green: "bg-green-400",
  red: "bg-stears_negative",
  blue: "bg-stears_accent"
}

type DotOptions = keyof typeof DOT_OPTIONS

export type AvatarProps = {
  size: keyof typeof AVATAR_SIZES
  src?: string
  alt: string
  dot?: DotOptions
  dotRing?: boolean
}

export function Avatar(props: AvatarProps) {
  const { size, src, alt, dot, dotRing = true } = props
  const [diameter, classSizes, dotSize] = AVATAR_SIZES[size]

  const dotColor = DOT_OPTIONS[dot as DotOptions] || ""
  return (
    <div
      className={`relative rounded-full ring-stears_white inline-block ${classSizes}`}
    >
      <Image
        src={src?.trim() || DEFAULT_AVATAR}
        alt={alt}
        width={Number(diameter)}
        height={Number(diameter)}
        layout="responsive"
        className="rounded-full"
      />

      {dot && (
        <div
          className={`dot ${dotColor} ${
            dotRing && "ring-2"
          } rounded-full ring-stears_white ${dotSize} absolute top-0 right-0`}
        ></div>
      )}
    </div>
  )
}

export default Avatar
